export default __webpack_public_path__ + "static/selar-a222391df53b25c3e4798d69bd6d0ae8.png";